export const REGISTER = 'SETTINGS_REGISTER';
export const VALIDATE_SUBDOMAIN = 'VALIDATE_SUBDOMAIN';
export const VERIFY_ACCOUNT = 'VERIFY_ACCOUNT';
